import { version } from '../../../../package.json';

export const APP_VERSION = version;
export const APPLICATION_NAME = 'Sqeptech Connect UI';
export const IDLE = 1500;
export const TIME_OUT = 300;
export const GROUP_UPLOAD_TEMPLATE_FILE_GUID =
  '11111111-1111-1111-1111-111111111111';
export const ESQEP_AUTH_TYPE = 'esqep.authType';
export const ESQEP_AUTH_SAML = 'esqep.auth.saml';

export const FORM_FIELD_OPTIONS = {
  appearance: 'outline',
  hideRequiredMarker: false,
  floatLabel: 'auto',
  subscriptSizing: 'dynamic',
};

export const CARD_OPTIONS = {
  appearance: 'outlined',
};

export const DIALOG_OPTIONS = {
  disableClose: true,
  hasBackdrop: true,
};
